<template>
  <div id="print-report">
    <!-- Print Only -->
    <HeaderPrint />
    <!-- / Print Only -->
    <v-card>
      <div class="pa-2 d-print-none">
        <v-row no-gutters class="align-center">
          <v-col cols="12" md="9">
            <v-btn
              small
              color="info"
              class="mr-4"
              @click="
                [$router.push({ name: 'LocalManagerUserCreate' }), showDialog()]
              "
            >
              <v-icon left> mdi-plus </v-icon>
              {{ $t("newAgent") }}
            </v-btn>
            <v-btn
              small
              class="white black--text d-print-none"
              @click="$printReport()"
            >
              <v-icon small left> mdi-printer </v-icon>
              {{ $t("print") }}
            </v-btn>
          </v-col>
          <v-col cols="12" md="3">
            <v-text-field
              :class="$vuetify.breakpoint.smAndDown ? 'mt-3' : ''"
              v-model="search"
              append-icon="mdi-magnify"
              :label="$t('search')"
              single-line
              hide-details
              solo-inverted
              dense
              clearable
            ></v-text-field>
          </v-col>
        </v-row>
      </div>

      <v-divider></v-divider>
      <v-data-table
        :headers="headers"
        :items="data"
        item-key="name"
        class="elevation-0 mb-3"
        :search="search"
        :dense="$vuetify.breakpoint.smAndDown"
        :footer-props="{
          'items-per-page-text': this.$t('rowsPerPage'),
        }"
      >
        <template v-slot:item.id="{ item }">
          <v-btn @click="$copy(item.id)" x-small>{{ item.id }}</v-btn>
        </template>

        <template v-slot:item.name_agent="{ item }">
          <a
            class="blue--text"
            @click="
              $profile.showProfileDrawer(
                item.id,
                '/localManager/agents/getAgent'
              )
            "
          >
            <v-icon color="blue" small> mdi-account</v-icon>
            {{ item.name_agent }}
          </a>
        </template>
        <template v-slot:item.action="{ item }">
          <v-btn-toggle dense>
            <v-btn
              :title="$t('bets')"
              small
              @click="
                $router.push({
                  name: 'LocalManagerBetHistoricAgent',
                  params: { id_agent: item.id },
                })
              "
            >
              <v-icon>mdi-text-box-search-outline</v-icon>
            </v-btn>

            <v-btn
              v-if="retailNotOne"
              :title="$t('credits')"
              small
              @click="
                $router.push({
                  name: 'LocalManagerCreditHistoricAgent',
                  params: { id_agent: item.id },
                })
              "
            >
              <v-icon>mdi-credit-card-outline</v-icon>
            </v-btn>

            <v-btn
              :title="$t('assessment')"
              small
              @click="
                $router.push({
                  name: 'LocalManagerFinancialApuration',
                  params: { id_agent: item.id },
                })
              "
            >
              <!-- <v-icon>mdi-cash-usd-outline</v-icon> -->
              <v-icon>mdi-currency-usd</v-icon>
            </v-btn>

            <v-btn
              :title="$t('edit')"
              small
              @click="
                [
                  $router.push({
                    name: 'LocalManagerUserEdit',
                    params: { id: item.id },
                  }),
                  showDialog(),
                ]
              "
            >
              <v-icon>mdi-account-edit</v-icon>
            </v-btn>
          </v-btn-toggle>
        </template>

        <template v-slot:item.status="{ item }">
          <v-switch
            v-model="item.status"
            color="success"
            v-on:click="changeStatus(item.id, item.status)"
            :disabled="disabledSwitch"
          ></v-switch>
        </template>
      </v-data-table>
    </v-card>
    <router-view :key="$route.fullPath"></router-view>
  </div>
</template>
<script>
import HeaderPrint from "@/components/common/header-print";
export default {
  name: "local-manager-users-list",
  components: {
    HeaderPrint,
  },
  data: () => ({
    dnone: false,
    data: [],
    search: "",
    actions: "",
    disabledSwitch: false,
  }),
  computed: {
    headers() {
      if (this.status != 2) {
        return [
          { text: "ID", align: "start", value: "id" },
          { text: this.$t("name"), value: "name_agent" },
          { text: "Login", value: "login_agent" },
          { text: this.$t("oddMargin"), value: "margin_odds" },
          { text: this.$t("currentCredit"), value: "balance" },
          { text: this.$t("retentionLimit"), value: "limit_retention" },
          {
            text: this.$t("status"),
            value: "status",
            align: " d-print-none",
            sortable: false,
          },
          {
            text: this.$t("actions"),
            value: "action",
            align: "center d-print-none",
            sortable: false,
          },
        ];
      } else {
        return [
          { text: "ID", align: "start", value: "id" },
          { text: this.$t("name"), value: "name_agent" },
          { text: "Login", value: "login_agent" },
          { text: this.$t("oddMargin"), value: "margin_odds" },
          { text: this.$t("currentCredit"), value: "balance" },
          { text: this.$t("retentionLimit"), value: "limit_retention" },
          {
            text: this.$t("status"),
            value: "status",
            align: " d-print-none",
            sortable: false,
          },
        ];
      }
    },
    refresh() {
      return this.$store.getters.getRefresh;
    },
    status() {
      return this.$store.state.filters.selectStatus.status;
    },
    saveFilters() {
      return this.$store.state.filters.save;
    },
    retailNotOne() {
      return this.$store.state.operator && this.$store.state.operator.retail != 1;
    },
  },
  watch: {
    saveFilters(val) {
      val && this.requestData();
    },
    refresh(val) {
      val && this.requestData();
      this.$store.commit("setRefresh", false);
    },
    status(val) {
      if (val != 0) return this.reset();
      if (val != 1) return this.reset();
      if (val != 2) return this.reset();
    },
  },
  methods: {
    reset() {
      this.data = [];
    },
    async requestData() {
      this.data = [];
      const request = await this.$request.post("/localManager/agents/list", {
        status: this.status,
      });

      if (request == undefined) return;
      this.data = request.dados;
      this.data.forEach((item) => {
        const limit =
          item.limit_retention >= 1000000 ? "Ilimitado" : item.limit_retention;

        this.$set(item, "limit_retention", limit);
        this.$set(item, "status", item.status === "1");
      });
      // Handle Hide Column Actions (Hide - Status Pendente '2')
      this.status == 2
        ? (this.disabledSwitch = true)
        : (this.disabledSwitch = false);
    },

    async changeStatus(id_agent, status) {
      const request = await this.$request.post(
        "/localManager/agents/changeStatus",
        {
          status: status === true ? 1 : 0,
          id_agent,
        }
      );

      this.$store.commit("setFeedbackSnack", {
        msg: request.messages,
        color: "success",
      });
    },

    // Show Dialog
    showDialog() {
      this.$store.commit("showDialog", true);
    },
  },
};
</script>
